<form [formGroup]="form" (submit)="onClickSave()" *ngIf="show.form">
    <div class="Loyalty ui-g-12 ui-md-12 ui-lg-12">
        <div class="ui-g">
            <div class="ui-g-9 ui-md-9 ui-lg-9">
            <h1 class="step-title">{{title}}</h1>
            </div>
            <div class="ui-g-3 ui-md-3 ui-lg-3 form-button-row">
            <button pButton class="k-generic-btn" type="button" icon="fa fa-arrow-left" iconPos="left" routerLink="/loyalty/point_transfer" label="{{ 'common.back' | translate }}"></button>
            <button pButton class="k-generic-btn" type="submit" icon="fa fa-floppy-o" iconPos="left" label="{{'common.save' | translate}}" [disabled]="!form.valid || !form.dirty"></button>
            </div>
        </div>
        <div class="">
            <div class="ui-g-12 ui-widget-header"><h3 class="title">{{translations.source}}</h3></div>
            <div class="ui-g ui-fluid row bgSection">
                    <br />
                    <div class="ui-g-12 ui-md-4 ui-lg-4 search-toolbar-input">
                        <div class="label">{{translations.cardSource}} *</div>
                        <!-- <input [attr.disabled]="true" class="inputSelect" type="text" pInputText formControlName="card_source" placeholder="{{translations.selectCardPlaceholder}}" />
                        <p-button pTooltip="{{ 'common.select' | translate }}" icon="fa fas fa-arrow-circle-right"  styleClass="selectButtonArrow ui-button-info" (onClick)="onOpenSelectCardSource()"></p-button>
                        <div class="clear_both"></div> -->

                        <input type="text" style="width: calc(100% - 70px) !important;float:left;" [disabled]="isCardSourcePresent" pInputText class="inputSelect" formControlName="card_source" placeholder="{{'pointTransfer.selectCardPlaceholder' | translate}}" />
                        <p-button pTooltip="{{ 'common.select' | translate }}" [disabled]="isCardSourcePresent" icon="fa fas fa-arrow-circle-right"  styleClass="selectButtonArrow ui-button-info" (onClick)="onOpenSelectCardSource()"></p-button>
                        <p-button pTooltip="{{ 'common.clear' | translate }}" icon="fa fa-close"  styleClass="selectButtonArrow ui-button-info" (onClick)="clearCardSource()"></p-button>

                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                        <div class="label">{{'common.reason' | translate}}</div>
                        <input [attr.disabled]="true" type="text" pInputText value="{{inputValue.reasonSource}}" />
                    </div>
            </div>
            <br />
            <div class="ui-g-12 ui-widget-header"><h3 class="title">{{translations.points}}</h3></div>
            <div class="ui-g ui-fluid row bgSection">
                <br />
                <div class="ui-g-12 ui-md-4 ui-lg-4 search-toolbar-input">
                    <div class="label">{{translations.accumulator}} *</div>
                    <p-dropdown [options]="accumulators" [(ngModel)]="selectedAcm" optionLabel="accumulatorCustomDescription" formControlName="accumulator" (onChange)="onChangeAccumulator()" placeholder="{{translations.selectAccumulatorPlaceholder}}"></p-dropdown>
                </div>
                <div class="ui-g-10 ui-md-2 ui-lg-2">
                    <div class="label">{{translations.points}} *</div>
                    <input min="1" max="{{maxPoints}}" style="height:32px;" type="number" pInputText formControlName="points" placeholder="{{translations.pointsPlaceholder}}" [attr.disabled]="(selectedAcm && maxPoints > 0) ? null : ''"/>
                    &nbsp;<span style="line-height:32px;" *ngIf="maxPoints > 0">(max {{maxPoints}})</span>
                </div>
            </div>
            <br />
            <div class="ui-g-12 ui-widget-header"><h3 class="title">{{translations.destination}}</h3></div>
            <div class="ui-g ui-fluid row bgSection">
                    <br />
                    <div class="ui-g-12 ui-md-4 ui-lg-4 search-toolbar-input">
                        <div class="label">{{translations.cardDestination}} *</div>
                        <!-- <input [attr.disabled]="true" class="inputSelect" type="text" pInputText formControlName="card_destination" placeholder="{{translations.selectCardPlaceholder}}"  />
                        <p-button pTooltip="{{ 'common.select' | translate }}" icon="fa fas fa-arrow-circle-right"  styleClass="selectButtonArrow ui-button-info" (onClick)="onOpenSelectCardDestination()"></p-button>
                        <div class="clear_both"></div> -->

                        <input pInputText type="text" style="width: calc(100% - 70px) !important;float:left;" [disabled]="isCardDestinationPresent || !sourceCard" pInputText class="inputSelect" formControlName="card_destination" placeholder="{{'pointTransfer.selectCardPlaceholder' | translate}}" />
                        <p-button pTooltip="{{ 'common.select' | translate }}" [disabled]="isCardDestinationPresent" icon="fa fas fa-arrow-circle-right"  styleClass="selectButtonArrow ui-button-info" (onClick)="onOpenSelectCardDestination()"></p-button>
                        <p-button pTooltip="{{ 'common.clear' | translate }}" icon="fa fa-close"  styleClass="selectButtonArrow ui-button-info" (onClick)="clearCardDestination()"></p-button>

                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                        <div class="label">{{'common.reason' | translate}}</div>
                        <input [attr.disabled]="true" type="text" pInputText value="{{inputValue.reasonDestination}}" />
                    </div>

            </div>
        </div>


    </div>
</form>


<!-- modal selezione carta sorgente -->
<p-dialog
    [(visible)]="show.selectCardSource"
    header="{{ 'card.select_card' | translate }}"
    [responsive]="true"
    showEffect="fade"
    [modal]="true"
>
    <app-card-selection-table *ngIf="show.selectCardSource" [flgBlkLst]="'0'" [cardNo]="form.get('card_source').value" (onCardSelect)="onSourceCardSelected($event)"></app-card-selection-table>
</p-dialog>


<!-- modal selezione carta destinazione -->
<p-dialog
    [(visible)]="show.selectCardDestination"
    header="{{ 'card.select_card' | translate }}"
    [responsive]="true"
    showEffect="fade"
    [modal]="true"
>
  <app-card-selection-table *ngIf="show.selectCardDestination" [flgBlkLst]="'0'" [cardNo]="form.get('card_destination').value" [channelId]="currentChannelId" (onCardSelect)="onDestinationCardSelected($event)"></app-card-selection-table>
</p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-point-transfer/form-point-transfer-loyalty/form-point-transfer-loyalty.component.html